module.exports = __webpack_public_path__ + "static/img_0-0aaeff2ec2491ea2305875c3145af611.png";